import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#080808]/96 backdrop-blur-xl border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); scrollTo('#home'); }}
          className="flex items-center cursor-pointer flex-shrink-0"
        >
          <img
            src="https://storage.readdy-site.link/project_files/0cb8efcd-9d2b-4dd1-9740-ad2e3153c9b7/d205aceb-a5bf-47b4-9517-1c4f4218b299_dj-logo.jpg?v=3b7c130c4994ae7a8692a9d96d877cdb"
            alt="Bugsie Productions"
            className="h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop nav — single Home link */}
        <nav className="hidden md:flex items-center gap-8">
          <a
            href="#home"
            onClick={(e) => { e.preventDefault(); scrollTo('#home'); }}
            className="text-gray-400 hover:text-[#D4AF37] text-sm tracking-widest uppercase font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            Home
          </a>
        </nav>

        {/* Right */}
        <div className="hidden md:flex items-center gap-5">
          <a
            href="tel:2069319361"
            className="flex items-center gap-2 text-gray-300 hover:text-[#D4AF37] transition-colors duration-300 text-sm whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-[#D4AF37] text-sm"></i>
            </div>
            (206) 931-9361
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
            className="bg-[#D4AF37] hover:bg-[#c49d2a] text-black text-xs font-bold px-6 py-2.5 rounded-full transition-all duration-300 tracking-widest uppercase whitespace-nowrap cursor-pointer"
          >
            Get a Quote
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#080808]/98 backdrop-blur-xl border-t border-white/8 px-6 py-7 flex flex-col gap-5">
          <a
            href="#home"
            onClick={(e) => { e.preventDefault(); scrollTo('#home'); }}
            className="text-gray-300 hover:text-[#D4AF37] text-base tracking-widest uppercase font-medium transition-colors duration-300 cursor-pointer"
          >
            Home
          </a>
          <a href="tel:2069319361" className="text-[#D4AF37] text-base font-semibold">(206) 931-9361</a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
            className="bg-[#D4AF37] text-black text-sm font-bold px-6 py-3 rounded-full text-center tracking-widest uppercase whitespace-nowrap cursor-pointer"
          >
            Get a Quote
          </a>
        </div>
      )}
    </header>
  );
}
